import React from 'react';
import { Box, Container, Typography } from '@mui/material';

/* Updated: 31 May 2025 */
const privacy = {
  PrivacyPolicy: {
    '1. Introduction': {
      '1.1. Purpose':
        'This Privacy Policy explains how MindMapper AI collects, uses, and protects your information when you use the Greenspot app.',
      '1.2. Acceptance':
        'By using Greenspot, you consent to the practices described in this policy.'
    },

    '2. Information We Collect': {
      '2.1. Plant Photos (Transient)':
        'When you choose to “Identify Plant,” the photo is sent to our secure server for a few seconds so our AI can recognise the species, then it is permanently deleted.',
      '2.2. Sensor Data':
        'Ambient-light readings from your device’s built-in light sensor are used to assess your plant’s lighting conditions. These data stay on your device.',
      '2.3. Local Storage':
        'Greenspot stores plant entries, measurement history, and your app preferences locally on your phone. We do not copy these data to the cloud.',
      '2.4. Device Information':
        'Anonymous details such as OS version, device model, and crash logs help us diagnose bugs and improve compatibility.'
    },

    '3. How We Use Your Information': {
      '3.1. Provide Core Services':
        'Identify your plant and deliver lighting recommendations based on sensor data.',
      '3.2. Personalisation':
        'Remember your saved plants and preferences so you can review past measurements.',
      '3.3. Diagnostics':
        'Analyse crash logs and performance metrics to keep the app stable and secure.',
      '3.4. Improvement (Aggregated Analytics)':
        'Use high-level, anonymised statistics to guide feature development and user-experience improvements.'
    },

    '4. Sharing Your Information': {
      '4.1. Service Providers':
        'Transient plant photos are processed on a server we control in Canada. Crash logs are stored with a privacy-focused cloud provider under strict confidentiality.',
      '4.2. Legal Requirements':
        'We may disclose data if required by law or to protect our rights and safety.',
      '4.3. Business Transfers':
        'If MindMapper AI is involved in a merger, acquisition, or asset sale, data may transfer as part of that transaction.'
    },

    '5. Data Security': {
      '5.1. Measures':
        'All data in transit use TLS encryption. Local files are stored in Android-protected app storage. Servers are firewall-protected and access-controlled.',
      '5.2. Limitations':
        'No security system is perfect. We cannot guarantee absolute security, but we work continually to protect your data.'
    },

    '6. Your Rights': {
      '6.1. Access & Correction':
        'Because Greenspot does not keep personal data on our servers, most access requests do not apply. You can edit or delete entries directly inside the app.',
      '6.2. Data Deletion':
        'Delete plants or clear Greenspot’s storage via Android Settings → Apps → Greenspot → Storage & Cache.',
      '6.3. Opt-Out':
        'Revoke camera or sensor permissions at any time (core features will stop working).'
    },

    "7. Children's Privacy": {
      '7.1. Age Restriction':
        'Greenspot is not intended for children under 13. We do not knowingly collect personal data from children.',
      '7.2. Parental Consent':
        'If you believe a child has provided data, contact us so we can delete any associated crash logs.'
    },

    '8. Third-Party Links': {
      '8.1. External Sites':
        'The app may link to third-party websites. Their privacy practices are not governed by this policy.',
      '8.2. Recommendations':
        'We encourage you to review the privacy policies of any external sites you visit.'
    },

    '9. Changes to This Policy': {
      '9.1. Updates':
        'We may update this Privacy Policy from time to time. Changes take effect upon posting.',
      '9.2. Notification':
        'If we make significant changes, we will notify you through the app or by email.'
    },

    '10. Contact Us': {
      '10.1. Support':
        'Questions or concerns? Email us at admin@mmai.live.'
    }
  }
};

function DisplayPrivacyGreenSpot() {
  return (
    <Box sx={{ py: 5 }}>
      <Container maxWidth="md" sx={{ mb: 10 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="h6" align="center" gutterBottom>
          Last updated: 31 May 2025
        </Typography>

        {Object.keys(privacy.PrivacyPolicy).map((section, index) => (
          <Box key={index} sx={{ mt: 2 }}>
            <Typography variant="h5" gutterBottom>
              {section}
            </Typography>

            {Object.keys(privacy.PrivacyPolicy[section]).map(
              (subSection, subIndex) => (
                <Box key={subIndex} sx={{ mt: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    {subSection}
                  </Typography>
                  <Typography>
                    {privacy.PrivacyPolicy[section][subSection]}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        ))}
      </Container>
    </Box>
  );
}

export default DisplayPrivacyGreenSpot;
